import React from "react";

const answerButtonText = (numberOfAnswers: number) => {
  if (!numberOfAnswers) {
    return "Ask a question";
  }

  return numberOfAnswers > 1
    ? `${numberOfAnswers} answered questions`
    : `${numberOfAnswers} answered question`;
};

interface QuestionAndAnswerLinkProps {
  numberOfAnswers: number;
}

const QuestionAndAnswerLink = ({
  numberOfAnswers,
}: QuestionAndAnswerLinkProps) => {
  const handleAnswersLinkClick = () => {
    const elementToJumpTo = document?.getElementById("customerQA");

    elementToJumpTo?.focus();
    elementToJumpTo?.scrollIntoView();
  };

  return (
    <button
      type="button"
      onClick={handleAnswersLinkClick}
      className="flex items-center border-0 text-green-500 hover:text-green-700 pl-1.5 bg-transparent border-l border-gray-300 lt:hidden mt-px"
      data-testid="questions-and-answers-link"
      style={{ fontFamily: "inherit" }}
    >
      <span className="product-subhead__rating-link !inline">
        {answerButtonText(numberOfAnswers)}
      </span>
    </button>
  );
};

export default QuestionAndAnswerLink;
